export default __webpack_public_path__ + "static/media/calendar.256f9d82.svg";